import { Component } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'src/app/services/message.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-activity-modal',
  templateUrl: './activity-modal.component.html',
  styleUrls: ['./activity-modal.component.scss'],
})
export class ActivityModalComponent {
  constructor(
    private clipboard: Clipboard,
    private message: MessageService,
    private modalRef: MatDialogRef<ActivityModalComponent>
  ) {}

  copy(text: any) {
    this.clipboard.copy(text);
    this.message.open('复制成功');
  }

  close() {
    this.modalRef.close();
  }
}
